import copyObject from './_copyObject.js';
import getSymbols from './_getSymbols.js';

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

export default copySymbols;



//////////////////
// WEBPACK FOOTER
// ../~/lodash-es/_copySymbols.js
// module id = 875
// module chunks = 0